export default __webpack_public_path__ + "static/media/expl-nn_04_EN.46f42617.png";